<template>
  <form role="form">
    <payout-form-group :label="$t('E-mail')"
                       class="form-group__label_align_start"
                       :required="true"
                       :has-errors="model.errors.has('email')">
      <filtered-input-wrapper v-model="model.values.email" :readonly="true"></filtered-input-wrapper>
      <payout-input-hint-block v-slot:hints :hint="$t('email_hint')"></payout-input-hint-block>
      <error-message-block v-slot:errors attribute="destinationAccount|*" :errors="model.errors"></error-message-block>
    </payout-form-group>

    <payout-input-amount-form-group :model="model"></payout-input-amount-form-group>

    <payout-evaluate-fee-form-group :model="model"></payout-evaluate-fee-form-group>

    <hr/>
    <payout-group-verification-type :model="model"></payout-group-verification-type>
  </form>
</template>

<script lang="ts">
import AbstractPayoutForm from "@/components/forms/payout/abstract/AbstractPayoutForm.vue";
import {Component} from "vue-property-decorator";
import PayoutFormGroup from "@/components/forms/payout/PayoutFormGroup.vue";
import PayoutInputHintBlock from "@/components/forms/payout/PayoutInputHintBlock.vue";
import ErrorMessageBlock from "@/components/forms/payout/ErrorMessageBlock.vue";
import PayoutTextfieldInputGroup from "@/components/forms/payout/PayoutTextfieldInputGroup.vue";
import PayoutInputAmountFormGroup from "@/components/forms/payout/PayoutInputAmountFormGroup.vue";
import PayoutEstimatedDestinationAmountFormGroup
  from "@/components/forms/payout/forms/PayoutEstimatedDestinationAmountFormGroup.vue";
import PayoutEvaluateFeeFormGroup from "@/components/forms/payout/PayoutEvaluateFeeFormGroup.vue";
import PayoutToggableHintPanelFormGroup
  from "@/components/forms/payout/hint/PayoutToggableHintPanelFormGroup.vue";
import PayoutFormNotificationBlock
  from "@/components/forms/payout/forms/PayoutFormNotificationBlock.vue";
import PayoutGroupVerificationType
  from "@/components/payout/verification/PayoutGroupVerificationType.vue";
import FilteredInputWrapper from "@/components/forms/payout/forms/inputs/FilteredInputWrapper.vue";
import PayoutHintPanel from "@/components/forms/payout/PayoutHintPanel.vue";
import DropdownKeyvalue from "@/components/forms/dropdown/DropdownKeyValue.vue";
import DynamicFeeValueText from "@/components/forms/payout/forms/crypto/DynamicFeeValueText.vue";
import {CapitalistChequeModel} from "@/components/forms/payout/forms/capitalist/capitalist-cheque";

@Component({
  name: "CapitalistChequePaymentForm",
  components: {
    DynamicFeeValueText,
    DropdownKeyvalue,
    PayoutHintPanel,
    FilteredInputWrapper,
    PayoutGroupVerificationType,
    PayoutFormNotificationBlock,
    PayoutToggableHintPanelFormGroup,
    PayoutEvaluateFeeFormGroup,
    PayoutEstimatedDestinationAmountFormGroup,
    PayoutInputAmountFormGroup,
    PayoutTextfieldInputGroup, ErrorMessageBlock, PayoutInputHintBlock, PayoutFormGroup}
})
export default class CapitalistChequePaymentForm extends AbstractPayoutForm {
  model = new CapitalistChequeModel()

}
</script>

<style scoped>

</style>

<i18n>
{
  "en": {
    "account_hint": "Phone number.",
    "Назначение платежа": "Description",
    "Адрес получателя": "Beneficiary address",
    "Динамическая комиссия": "Dynamic commission",
    "description_hint": "The destination will be displayed when the check is viewed and redeemed by the Recipient.",
    "email_hint": "The email address of the Recipient. The Recipient will receive the check by email."
  },
  "ru": {
    "account_hint": "Номер телефона.",
    "email_hint": "Чек будет отправлен на этот адрес.",
    "description_hint": "Назначение будет отображаться при просмотре и погашении чека Получателем."
  }
}
</i18n>
